// Shared duration/comment helpers - previously duplicated across
// TimeEntries.js and TelegramMessages.js.

export const parseDurationToMinutes = (duration) => {
  if (!duration) return 0;

  if (typeof duration === 'number') {
    return Math.round(duration * 60);
  }

  if (typeof duration === 'string') {
    if (duration.startsWith('PT')) {
      const hoursMatch = duration.match(/(\d+)H/);
      const minutesMatch = duration.match(/(\d+)M/);
      const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
      const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;
      return hours * 60 + minutes;
    }

    const parsed = parseFloat(duration);
    if (!isNaN(parsed)) {
      return Math.round(parsed * 60);
    }
  }

  return 0;
};

export const formatDuration = (duration) => `${parseDurationToMinutes(duration)} min`;

export const calculateTimeDifferenceMinutes = (createdAt, updatedAt) => {
  if (!createdAt || !updatedAt) return 0;
  const created = new Date(createdAt);
  const updated = new Date(updatedAt);
  return Math.floor((updated - created) / (1000 * 60));
};

export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};

// Extracts plain text from an OpenProject comment field, which can be a
// bare string or a { raw, html, format } object depending on the source.
export const getCommentText = (comment, fallback = 'No comment') => {
  if (!comment) return fallback;
  if (typeof comment === 'string') return comment || fallback;
  return comment.raw || comment.html || comment.format || fallback;
};
